import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["display", "form", "input"]

    edit() {
        this.displayTarget.classList.add("hidden")
        this.formTarget.classList.remove("hidden")
        if (this.hasInputTarget) this.inputTarget.focus()
    }

    cancel() {
        this.formTarget.classList.add("hidden")
        this.displayTarget.classList.remove("hidden")
    }
}
